import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthUtility } from '../utility/auth-utility';
import { ToastrService } from 'ngx-toastr';

export const roleGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const toastr = inject(ToastrService);

    if (!AuthUtility.isAuthenticated()) {
        router.navigate(['/login']);
        return false;
    }

    // Si el acceso fue iniciado mediante URL de token (/token/ey...),
    // se garantiza acceso exclusivo a registro-asistencia sin importar el rol.
    const isTokenAccess = sessionStorage.getItem('lector_token_access') === 'true';
    if (isTokenAccess) {
        const routePath = route.routeConfig?.path || state.url;
        if (routePath.includes('registro-asistencia') || state.url.includes('registro-asistencia')) {
            return true;
        }
        // Para cualquier otra ruta intentada desde un acceso por token, redirigir a registro
        router.navigate(['/registro-asistencia']);
        return false;
    }

    const user = AuthUtility.getValueUserAS();

    const allowedRoles = route.data['roles'] as string[];

    if (user && user.cPerfil) {
        const userRole = user.cPerfil.toUpperCase();

        if (allowedRoles && allowedRoles.length > 0) {
            // Check if user has one of the allowed roles
            const hasRole = allowedRoles.some(role => userRole.includes(role.toUpperCase()));
            if (hasRole) return true;
        } else {
            // Default behavior if no specific roles provided
            // Here SUPER USER or ADMIN can be allowed by default if unconfigured
            if (userRole.includes('SUPER USER') || userRole.includes('ADMIN')) {
                return true;
            }
        }
    }

    toastr.warning('No tienes permisos para acceder a este módulo.', 'Acceso Denegado');
    router.navigate(['/']); // Redirect to dashboard
    return false;
};
